(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5467],{

/***/ 53725:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[chain]/collection/[contract]",
      function () {
        return __webpack_require__(30957);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 30957:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _contract_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/primitives/index.ts + 10 modules
var primitives = __webpack_require__(30758);
// EXTERNAL MODULE: ./node_modules/@reservoir0x/reservoir-kit-ui/dist/index.mjs + 23 modules
var dist = __webpack_require__(17175);
// EXTERNAL MODULE: ./components/Layout.tsx
var Layout = __webpack_require__(51943);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./utils/truncate.ts
var truncate = __webpack_require__(39525);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-solid-svg-icons/index.mjs
var free_solid_svg_icons = __webpack_require__(59417);
// EXTERNAL MODULE: ./node_modules/@fortawesome/react-fontawesome/index.es.js + 1 modules
var index_es = __webpack_require__(99603);
;// CONCATENATED MODULE: ./components/buttons/AddToCart.tsx
// PARKED: cart checkout executed via Reservoir — paused during the Alchemy migration.
const AddToCart = ()=>{
    // HIDDEN during the browse-only relaunch: native trading is parked, so these
    // controls render nothing. Buying happens via the OpenSeaButton outbound link.
    // To restore, render <TradePausedButton .../> again in the component body below.
    return null;
};
/* harmony default export */ var buttons_AddToCart = (AddToCart);

// EXTERNAL MODULE: ./components/buttons/BuyNow.tsx
var BuyNow = __webpack_require__(66918);
// EXTERNAL MODULE: ./context/ToastContextProvider.tsx + 4 modules
var ToastContextProvider = __webpack_require__(98045);
// EXTERNAL MODULE: ./hooks/index.ts + 7 modules
var hooks = __webpack_require__(79569);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./utils/numbers.ts + 1 modules
var numbers = __webpack_require__(23701);
;// CONCATENATED MODULE: ./components/collections/TokenCard.tsx












/* harmony default export */ var TokenCard = ((param)=>{
    let { token , address , rarityEnabled =true , addToCartEnabled =true , showAsk =true , mutate , onMediaPlayed , tokenCount , showSource =true  } = param;
    var _token_token, _token_token_owner, _token_token1, _token_token2, _token_token3, _token_token4, _token_token5, _token_token6, _token_token7, _token_token8, _token_token9, _token_token10, _token_token11, _token_token12, _token_market, _token_market_floorAsk, _token_market1, _token_market_floorAsk1, _token_market_floorAsk_price, _token_market_floorAsk_price_amount, _token_market2, _token_market_floorAsk2, _token_market_floorAsk_price1, _token_market_floorAsk_price_currency, _token_market3, _token_market_floorAsk3, _token_market4, _token_market_floorAsk4, _token_market5, _token_market_floorAsk5, _token_market_floorAsk_source, _token_market6, _token_market_floorAsk6, _token_market_floorAsk_source1, _token_token13, _token_token_lastSale, _token_token_lastSale_price, _token_token_lastSale_price_amount, _token_token_lastSale_price_amount1, _token_token_lastSale_price_currency, _token_token_lastSale_price_currency1, _token_market7, _token_market_floorAsk7, _token_market_floorAsk_price2, _token_token14, _token_token15, _token_token_collection;
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const mediaType = (0,dist/* extractMediaType */.uh)(token === null || token === void 0 ? void 0 : token.token);
    const showMedia = mediaType === "mp4" || mediaType === "mp3" || mediaType === "m4a" || mediaType === "wav" || mediaType === "mov";
    const { routePrefix , proxyApi  } = (0,hooks/* useMarketplaceChain */.gw)();
    const tokenIsInCart = token && (token === null || token === void 0 ? void 0 : token.isInCart);
    const isOwner = (token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : (_token_token_owner = _token_token.owner) === null || _token_token_owner === void 0 ? void 0 : _token_token_owner.toLowerCase()) !== (address === null || address === void 0 ? void 0 : address.toLowerCase());
    const is1155 = (token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.kind) === "erc1155";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
        css: {
            borderRadius: 8,
            overflow: "hidden",
            background: "$neutralBgSubtle",
            $$shadowColor: "$colors$panelShadow",
            boxShadow: "0 8px 12px 0px $$shadowColor",
            position: "relative",
            "&:hover > a > div > img": {
                transform: "scale(1.1)"
            },
            "@sm": {
                "&:hover .token-button-container": {
                    bottom: 0
                }
            }
        },
        children: [
            tokenCount && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                justify: "center",
                align: "center",
                css: {
                    borderRadius: 8,
                    px: "$2",
                    py: "$1",
                    mr: "$2",
                    position: "absolute",
                    left: "$2",
                    top: "$2",
                    zIndex: 1,
                    maxWidth: "50%",
                    backgroundColor: "rgba(	38, 41, 43, 0.3)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                    css: {
                        color: "$whiteA12"
                    },
                    ellipsify: true,
                    children: [
                        "x",
                        tokenCount
                    ]
                })
            }),
            is1155 && (token === null || token === void 0 ? void 0 : (_token_token2 = token.token) === null || _token_token2 === void 0 ? void 0 : _token_token2.supply) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                justify: "center",
                align: "center",
                css: {
                    borderRadius: 8,
                    px: "$2",
                    py: "$1",
                    mr: "$2",
                    position: "absolute",
                    left: "$2",
                    top: "$2",
                    zIndex: 1,
                    maxWidth: "50%",
                    backgroundColor: "rgba(	38, 41, 43, 0.3)",
                    backdropFilter: "blur(2px)"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                    css: {
                        color: "$whiteA12"
                    },
                    ellipsify: true,
                    children: [
                        "x",
                        (0,numbers/* formatNumber */.uf)(token === null || token === void 0 ? void 0 : (_token_token3 = token.token) === null || _token_token3 === void 0 ? void 0 : _token_token3.supply, 0, true)
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                justify: "center",
                align: "center",
                css: {
                    borderRadius: "99999px",
                    width: 48,
                    height: 48,
                    backgroundColor: "$primary9",
                    position: "absolute",
                    right: "$2",
                    zIndex: 1,
                    transition: "visibility 0s linear ".concat(tokenIsInCart ? "" : "250ms", ", opacity 250ms ease-in-out, top 250ms ease-in-out"),
                    opacity: tokenIsInCart ? 1 : 0,
                    top: tokenIsInCart ? "$2" : 50,
                    visibility: tokenIsInCart ? "visible" : "hidden",
                    color: "white"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faCheck */.LEp,
                    width: 20,
                    height: 20
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                passHref: true,
                href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token4 = token.token) === null || _token_token4 === void 0 ? void 0 : _token_token4.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token5 = token.token) === null || _token_token5 === void 0 ? void 0 : _token_token5.tokenId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                    css: {
                        background: "$gray3",
                        overflow: "hidden"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist/* TokenMedia */.Y1, {
                        token: token === null || token === void 0 ? void 0 : token.token,
                        style: {
                            width: "100%",
                            transition: "transform .3s ease-in-out",
                            maxHeight: 720,
                            height: "100%",
                            borderRadius: 0,
                            aspectRatio: "1/1"
                        },
                        staticOnly: !showMedia,
                        imageResolution: "medium",
                        audioOptions: {
                            onPlay: (e)=>{
                                onMediaPlayed === null || onMediaPlayed === void 0 ? void 0 : onMediaPlayed(e);
                            }
                        },
                        videoOptions: {
                            onPlay: (e)=>{
                                onMediaPlayed === null || onMediaPlayed === void 0 ? void 0 : onMediaPlayed(e);
                            }
                        },
                        onRefreshToken: ()=>{
                            mutate === null || mutate === void 0 ? void 0 : mutate();
                            addToast === null || addToast === void 0 ? void 0 : addToast({
                                title: "Refresh token",
                                description: "Request to refresh this token was accepted."
                            });
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/".concat(routePrefix, "/asset/").concat(token === null || token === void 0 ? void 0 : (_token_token6 = token.token) === null || _token_token6 === void 0 ? void 0 : _token_token6.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token7 = token.token) === null || _token_token7 === void 0 ? void 0 : _token_token7.tokenId),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        p: "$4",
                        minHeight: showAsk ? 132 : 0,
                        cursor: "pointer"
                    },
                    direction: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                mb: "$2"
                            },
                            align: "center",
                            justify: "between",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$1",
                                        minWidth: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle1",
                                            as: "p",
                                            ellipsify: true,
                                            css: {
                                                fontWeight: 600,
                                                pr: "$1",
                                                flex: 1
                                            },
                                            children: [
                                                (token === null || token === void 0 ? void 0 : (_token_token8 = token.token) === null || _token_token8 === void 0 ? void 0 : _token_token8.name) || "#" + (token === null || token === void 0 ? void 0 : (_token_token9 = token.token) === null || _token_token9 === void 0 ? void 0 : _token_token9.tokenId),
                                                " "
                                            ]
                                        }),
                                        (token === null || token === void 0 ? void 0 : (_token_token10 = token.token) === null || _token_token10 === void 0 ? void 0 : _token_token10.isFlagged) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Tooltip */.u, {
                                            content: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "body3",
                                                as: "p",
                                                children: "Not tradeable on OpenSea"
                                            }),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                css: {
                                                    color: "$red10"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                    icon: free_solid_svg_icons/* faCircleExclamation */.xHz,
                                                    width: 16,
                                                    height: 16
                                                })
                                            })
                                        })
                                    ]
                                }),
                                rarityEnabled && !is1155 && (token === null || token === void 0 ? void 0 : (_token_token11 = token.token) === null || _token_token11 === void 0 ? void 0 : _token_token11.rarityRank) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                    css: {
                                        px: "$1",
                                        py: 2,
                                        background: "$gray3",
                                        borderRadius: 8,
                                        minWidth: "max-content"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                        align: "center",
                                        css: {
                                            gap: 5
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                style: {
                                                    width: 13,
                                                    height: 13
                                                },
                                                src: "/icons/rarity-icon.svg"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                style: "subtitle3",
                                                as: "p",
                                                children: (0,numbers/* formatNumber */.uf)(token === null || token === void 0 ? void 0 : (_token_token12 = token.token) === null || _token_token12 === void 0 ? void 0 : _token_token12.rarityRank)
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        showAsk && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            align: "center",
                            justify: "between",
                            css: {
                                gap: "$2"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    align: "center",
                                    css: {
                                        gap: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                            css: {
                                                flex: 1,
                                                minWidth: 0,
                                                width: "100%",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis"
                                            },
                                            children: (token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : _token_market_floorAsk.price) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                                logoHeight: 18,
                                                amount: token === null || token === void 0 ? void 0 : (_token_market1 = token.market) === null || _token_market1 === void 0 ? void 0 : (_token_market_floorAsk1 = _token_market1.floorAsk) === null || _token_market_floorAsk1 === void 0 ? void 0 : (_token_market_floorAsk_price = _token_market_floorAsk1.price) === null || _token_market_floorAsk_price === void 0 ? void 0 : (_token_market_floorAsk_price_amount = _token_market_floorAsk_price.amount) === null || _token_market_floorAsk_price_amount === void 0 ? void 0 : _token_market_floorAsk_price_amount.decimal,
                                                address: token === null || token === void 0 ? void 0 : (_token_market2 = token.market) === null || _token_market2 === void 0 ? void 0 : (_token_market_floorAsk2 = _token_market2.floorAsk) === null || _token_market_floorAsk2 === void 0 ? void 0 : (_token_market_floorAsk_price1 = _token_market_floorAsk2.price) === null || _token_market_floorAsk_price1 === void 0 ? void 0 : (_token_market_floorAsk_price_currency = _token_market_floorAsk_price1.currency) === null || _token_market_floorAsk_price_currency === void 0 ? void 0 : _token_market_floorAsk_price_currency.contract,
                                                textStyle: "h6",
                                                css: {
                                                    textOverflow: "ellipsis",
                                                    minWidth: 0,
                                                    with: "100%",
                                                    overflow: "hidden",
                                                    fontSize: 18
                                                },
                                                maximumFractionDigits: 4
                                            })
                                        }),
                                        is1155 && (token === null || token === void 0 ? void 0 : (_token_market3 = token.market) === null || _token_market3 === void 0 ? void 0 : (_token_market_floorAsk3 = _token_market3.floorAsk) === null || _token_market_floorAsk3 === void 0 ? void 0 : _token_market_floorAsk3.quantityRemaining) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                            style: "subtitle2",
                                            ellipsify: true,
                                            children: [
                                                "x",
                                                (0,numbers/* formatNumber */.uf)(token === null || token === void 0 ? void 0 : (_token_market4 = token.market) === null || _token_market4 === void 0 ? void 0 : (_token_market_floorAsk4 = _token_market4.floorAsk) === null || _token_market_floorAsk4 === void 0 ? void 0 : _token_market_floorAsk4.quantityRemaining, 0, true)
                                            ]
                                        }) : null
                                    ]
                                }),
                                showSource && (token === null || token === void 0 ? void 0 : (_token_market5 = token.market) === null || _token_market5 === void 0 ? void 0 : (_token_market_floorAsk5 = _token_market5.floorAsk) === null || _token_market_floorAsk5 === void 0 ? void 0 : (_token_market_floorAsk_source = _token_market_floorAsk5.source) === null || _token_market_floorAsk_source === void 0 ? void 0 : _token_market_floorAsk_source.name) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    style: {
                                        width: 20,
                                        height: 20,
                                        borderRadius: "50%"
                                    },
                                    onClick: (e)=>{
                                        var _token_market, _token_market_floorAsk, _token_market_floorAsk_source, _token_token, _token_token1;
                                        e.preventDefault();
                                        e.stopPropagation();
                                        const url = "".concat(proxyApi, "/redirect/sources/").concat(token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : (_token_market_floorAsk_source = _token_market_floorAsk.source) === null || _token_market_floorAsk_source === void 0 ? void 0 : _token_market_floorAsk_source.domain, "/tokens/").concat(token === null || token === void 0 ? void 0 : (_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.contract, ":").concat(token === null || token === void 0 ? void 0 : (_token_token1 = token.token) === null || _token_token1 === void 0 ? void 0 : _token_token1.tokenId, "/link/v2");
                                        window.open(url, "_blank");
                                    },
                                    src: "".concat(proxyApi, "/redirect/sources/").concat(token === null || token === void 0 ? void 0 : (_token_market6 = token.market) === null || _token_market6 === void 0 ? void 0 : (_token_market_floorAsk6 = _token_market6.floorAsk) === null || _token_market_floorAsk6 === void 0 ? void 0 : (_token_market_floorAsk_source1 = _token_market_floorAsk6.source) === null || _token_market_floorAsk_source1 === void 0 ? void 0 : _token_market_floorAsk_source1.domain, "/logo/v2")
                                }) : null
                            ]
                        }),
                        (token === null || token === void 0 ? void 0 : (_token_token13 = token.token) === null || _token_token13 === void 0 ? void 0 : (_token_token_lastSale = _token_token13.lastSale) === null || _token_token_lastSale === void 0 ? void 0 : (_token_token_lastSale_price = _token_token_lastSale.price) === null || _token_token_lastSale_price === void 0 ? void 0 : (_token_token_lastSale_price_amount = _token_token_lastSale_price.amount) === null || _token_token_lastSale_price_amount === void 0 ? void 0 : _token_token_lastSale_price_amount.decimal) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                            css: {
                                gap: "$2",
                                marginTop: "auto"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                    css: {
                                        color: "$gray11"
                                    },
                                    style: "subtitle3",
                                    children: "Last Sale"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* FormatCryptoCurrency */.gv, {
                                    logoHeight: 12,
                                    amount: (_token_token_lastSale_price_amount1 = token.token.lastSale.price.amount) === null || _token_token_lastSale_price_amount1 === void 0 ? void 0 : _token_token_lastSale_price_amount1.decimal,
                                    address: (_token_token_lastSale_price_currency = token.token.lastSale.price.currency) === null || _token_token_lastSale_price_currency === void 0 ? void 0 : _token_token_lastSale_price_currency.contract,
                                    decimals: (_token_token_lastSale_price_currency1 = token.token.lastSale.price.currency) === null || _token_token_lastSale_price_currency1 === void 0 ? void 0 : _token_token_lastSale_price_currency1.decimals,
                                    textStyle: "subtitle3",
                                    maximumFractionDigits: 4
                                })
                            ]
                        }) : null
                    ]
                })
            }),
            showAsk && isOwner && (token === null || token === void 0 ? void 0 : (_token_market7 = token.market) === null || _token_market7 === void 0 ? void 0 : (_token_market_floorAsk7 = _token_market7.floorAsk) === null || _token_market_floorAsk7 === void 0 ? void 0 : (_token_market_floorAsk_price2 = _token_market_floorAsk7.price) === null || _token_market_floorAsk_price2 === void 0 ? void 0 : _token_market_floorAsk_price2.amount) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                className: "token-button-container",
                css: {
                    width: "100%",
                    transition: "bottom 0.25s ease-in-out",
                    position: "absolute",
                    bottom: -44,
                    left: 0,
                    right: 0,
                    gap: 1
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BuyNow/* default */.Z, {
                        tokenId: (_token_token14 = token.token) === null || _token_token14 === void 0 ? void 0 : _token_token14.tokenId,
                        collectionId: (_token_token15 = token.token) === null || _token_token15 === void 0 ? void 0 : (_token_token_collection = _token_token15.collection) === null || _token_token_collection === void 0 ? void 0 : _token_token_collection.id,
                        mutate: mutate,
                        buttonCss: {
                            justifyContent: "center",
                            flex: 1
                        },
                        buttonProps: {
                            corners: "square"
                        },
                        buttonChildren: "Buy Now"
                    }),
                    addToCartEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_AddToCart, {
                        token: token,
                        buttonCss: {
                            width: 52,
                            p: 0,
                            justifyContent: "center"
                        },
                        buttonProps: {
                            corners: "square"
                        }
                    }) : null
                ]
            }) : null
        ]
    });
});

// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./utils/router.ts
/**
   * Adds a param to the URL string. Multiple params with the same name
   * and different values can be added.
   * @param router Next router
   * @param name The name of the param.
   * @param value The value of the param.
   */ const addParam = (router, name, value)=>{
    const { [name]: param , ...rest } = router.query;
    let newQuery;
    if (!param) {
        newQuery = {
            ...rest,
            [name]: value
        };
    } else if (Array.isArray(param)) {
        if (param.indexOf(encodeURIComponent(value)) > -1) return;
        newQuery = {
            ...rest,
            [name]: [
                ...param,
                value
            ]
        };
    } else {
        if (param === encodeURIComponent(value)) return;
        newQuery = {
            ...rest,
            [name]: [
                param,
                value
            ]
        };
    }
    router.push({
        query: newQuery
    }, undefined, {
        shallow: true
    });
};
/**
   * Removes the provided params with a specific value from the URL.
   * @param router Next router
   * @param name The name of the param.
   * @param value The value of the param.
   */ const removeParam = (router, name, value)=>{
    const { [name]: param , ...rest } = router.query;
    if (!param) {
        return;
    }
    let newQuery;
    if (value && Array.isArray(param) && !Array.isArray(value)) {
        newQuery = {
            ...rest,
            [name]: param.filter((element)=>element !== value)
        };
    } else {
        newQuery = {
            ...rest
        };
    }
    router.push({
        query: newQuery
    }, undefined, {
        shallow: true
    });
};
/**
   * Checks whether a param is exposed in the URL string or not.
   * @param router Next router
   * @param name The name of the param.
   * @param value Optional, the param must have the specified value.
   * @returns true/false depending on the presence of the param.
   */ const hasParam = (router, name, value)=>{
    const { [name]: param  } = router.query;
    if (!value) {
        return !!param;
    }
    if (!param) {
        return false;
    } else if (Array.isArray(param)) {
        return param.indexOf(value.toString()) > -1;
    } else {
        return param === value;
    }
};
/**
   * Deletes all 'attribute' params from the URL string
  */ function clearAllAttributes(router) {
    Object.keys(router.query).find((key)=>{
        if (key.startsWith("attributes[") && key.endsWith("]") && router.query[key] !== "") {
            delete router.query[key];
        }
    });
    router.push({
        query: {
            ...router.query
        }
    }, undefined, {
        shallow: true
    });
}


// EXTERNAL MODULE: ./node_modules/react-window/dist/index.esm.js + 4 modules
var index_esm = __webpack_require__(85280);
;// CONCATENATED MODULE: ./components/collections/filters/AttributeSelector.tsx








const AttributeSelector = (param)=>{
    let { attribute , scrollToTop  } = param;
    const router = (0,next_router.useRouter)();
    const [open, setOpen] = (0,react.useState)(false);
    const sortedAttributes = (0,react.useMemo)(()=>{
        var _attribute_values;
        return attribute === null || attribute === void 0 ? void 0 : (_attribute_values = attribute.values) === null || _attribute_values === void 0 ? void 0 : _attribute_values.sort((a, b)=>{
            if (!a.count || !b.count) {
                return 0;
            } else {
                return b.count - a.count;
            }
        });
    }, [
        attribute
    ]);
    const AttributeRow = (param)=>{
        let { index , style  } = param;
        var _attribute_values;
        const currentAttribute = attribute === null || attribute === void 0 ? void 0 : (_attribute_values = attribute.values) === null || _attribute_values === void 0 ? void 0 : _attribute_values[index];
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            style: style,
            css: {
                gap: "$3"
            },
            align: "center",
            onClick: ()=>{
                if (hasParam(router, "attributes[".concat(attribute.key, "]"), currentAttribute === null || currentAttribute === void 0 ? void 0 : currentAttribute.value)) {
                    removeParam(router, "attributes[".concat(attribute.key, "]"), currentAttribute === null || currentAttribute === void 0 ? void 0 : currentAttribute.value);
                } else {
                    addParam(router, "attributes[".concat(attribute.key, "]"), (currentAttribute === null || currentAttribute === void 0 ? void 0 : currentAttribute.value) || "");
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "body1",
                    css: {
                        color: "$gray11",
                        flex: 1,
                        whiteSpace: "pre",
                        textOverflow: "ellipsis",
                        overflow: "hidden"
                    },
                    children: currentAttribute === null || currentAttribute === void 0 ? void 0 : currentAttribute.value
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "body3",
                    css: {
                        color: "$gray11"
                    },
                    children: currentAttribute === null || currentAttribute === void 0 ? void 0 : currentAttribute.count
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    align: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Switch */.rs, {
                        checked: hasParam(router, "attributes[".concat(attribute.key, "]"), currentAttribute === null || currentAttribute === void 0 ? void 0 : currentAttribute.value),
                        onCheckedChange: (checked)=>{
                            if (checked) {
                                addParam(router, "attributes[".concat(attribute.key, "]"), (currentAttribute === null || currentAttribute === void 0 ? void 0 : currentAttribute.value) || "");
                            } else {
                                removeParam(router, "attributes[".concat(attribute.key, "]"), currentAttribute === null || currentAttribute === void 0 ? void 0 : currentAttribute.value);
                            }
                            scrollToTop();
                        }
                    })
                })
            ]
        }, index);
    };
    var _sortedAttributes_length, _sortedAttributes_length1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
        css: {
            pt: "$3",
            px: "$4",
            borderBottom: "1px solid $gray7",
            cursor: "pointer",
            "@md": {
                px: "0"
            }
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                align: "center",
                justify: "between",
                css: {
                    mb: "$3",
                    cursor: "pointer"
                },
                onClick: ()=>setOpen(!open),
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        as: "h5",
                        style: "subtitle1",
                        ellipsify: true,
                        children: attribute.key
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faChevronDown */.ptq,
                        style: {
                            transform: open ? "rotate(180deg)" : "rotate(0)",
                            transition: ".3s"
                        },
                        width: 16,
                        height: 16
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                css: {
                    paddingBottom: open ? 8 : 0
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* FixedSizeList */.t7, {
                    height: open ? sortedAttributes && (sortedAttributes === null || sortedAttributes === void 0 ? void 0 : sortedAttributes.length) >= 7 ? 300 : ((_sortedAttributes_length = sortedAttributes === null || sortedAttributes === void 0 ? void 0 : sortedAttributes.length) !== null && _sortedAttributes_length !== void 0 ? _sortedAttributes_length : 1) * 36 : 0,
                    itemCount: (_sortedAttributes_length1 = sortedAttributes === null || sortedAttributes === void 0 ? void 0 : sortedAttributes.length) !== null && _sortedAttributes_length1 !== void 0 ? _sortedAttributes_length1 : 1,
                    itemSize: 36,
                    width: "100%",
                    style: {
                        overflow: "auto",
                        transition: "max-height .3s ease-in-out"
                    },
                    children: AttributeRow
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@radix-ui/react-collapsible/dist/index.mjs + 10 modules
var react_collapsible_dist = __webpack_require__(49665);
// EXTERNAL MODULE: ./components/primitives/Collapsible.tsx
var Collapsible = __webpack_require__(61194);
// EXTERNAL MODULE: ./components/navbar/index.tsx + 9 modules
var navbar = __webpack_require__(42927);
// EXTERNAL MODULE: ./components/common/LoadingSpinner.tsx
var LoadingSpinner = __webpack_require__(74431);
;// CONCATENATED MODULE: ./components/collections/filters/AttributeFilters.tsx







const AttributeFilters = (param)=>{
    let { attributes , open , setOpen , scrollToTop  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_collapsible_dist/* Root */.fC, {
        open: open,
        onOpenChange: setOpen,
        style: {
            transition: "width .5s",
            width: open ? 320 : 0
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapsible/* CollapsibleContent */.Fw, {
            css: {
                position: "sticky",
                top: 16 + 80,
                height: "calc(100vh - ".concat(navbar/* NAVBAR_HEIGHT */.ik, "px - 32px)"),
                overflow: "auto",
                marginBottom: 16,
                background: "transparent",
                border: "none",
                borderRadius: 0
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    "& > div:first-of-type": {
                        pt: 0
                    }
                },
                children: [
                    attributes && attributes.filter((attribute)=>attribute.kind != "number").map((attribute)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeSelector, {
                            attribute: attribute,
                            scrollToTop: scrollToTop
                        }, attribute.key)),
                    (!attributes || !attributes.length) && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        justify: "center",
                        align: "center",
                        css: {
                            height: 150
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingSpinner/* default */.Z, {
                            css: {
                                justifySelf: "center"
                            }
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./components/common/FilterButton.tsx
var FilterButton = __webpack_require__(57813);
;// CONCATENATED MODULE: ./components/buttons/CollectionOffer.tsx
// PARKED: trading execution is paused during the Alchemy migration.
const CollectionOffer = ()=>{
    // HIDDEN during the browse-only relaunch: native trading is parked, so these
    // controls render nothing. Buying happens via the OpenSeaButton outbound link.
    // To restore, render <TradePausedButton .../> again in the component body below.
    return null;
};
/* harmony default export */ var buttons_CollectionOffer = (CollectionOffer);

;// CONCATENATED MODULE: ./components/collections/filters/SelectedAttributes.tsx








const SelectedAttributes = (param)=>{
    let { collection , mutate  } = param;
    const router = (0,next_router.useRouter)();
    const [filters, setFilters] = (0,react.useState)([]);
    (0,react.useEffect)(()=>{
        let filters = [];
        // Extract all queries of attribute type
        // and convert into token format
        Object.keys({
            ...router.query
        }).map((key)=>{
            if (key.startsWith("attributes[") && key.endsWith("]") && router.query[key] !== "") {
                if (Array.isArray(router.query[key])) {
                    let values = router.query[key];
                    values.forEach((value)=>{
                        filters.push({
                            key: key.slice(11, -1),
                            value: value
                        });
                    });
                } else {
                    filters.push({
                        key: key.slice(11, -1),
                        value: router.query[key]
                    });
                }
            }
        });
        setFilters(filters);
    }, [
        router.query
    ]);
    if (filters.length === 0) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        wrap: "wrap",
        align: "center",
        css: {
            mb: "$4"
        },
        children: [
            filters.map((param)=>/*#__PURE__*/ {
                let { key , value  } = param;
                return (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
                    onClick: ()=>{
                        removeParam(router, "attributes[".concat(key, "]"), value);
                    },
                    color: "gray3",
                    css: {
                        mr: "$3"
                    },
                    size: "small",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                            style: "body1",
                            css: {
                                color: "$gray12"
                            },
                            children: [
                                key,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            style: "subtitle1",
                            children: value
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                            css: {
                                color: "$gray9"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                icon: free_solid_svg_icons/* faClose */.YIN,
                                width: "16",
                                height: "16"
                            })
                        })
                    ]
                }, key + value);
            }),
            filters.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                onClick: ()=>{
                    clearAllAttributes(router);
                },
                color: "ghost",
                css: {
                    color: "$primary11",
                    fontWeight: 500,
                    px: "$4"
                },
                children: "Clear all"
            }),
            filters.length === 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(buttons_CollectionOffer, {
                collection: collection,
                buttonChildren: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        "Bid on ",
                        filters.length,
                        " ",
                        filters.length > 1 ? "Traits" : "Trait"
                    ]
                }),
                buttonProps: {
                    css: {
                        color: "$primary11",
                        fontWeight: 500,
                        px: "$4"
                    },
                    color: "ghost",
                    disabled: false
                },
                buttonCss: {
                    px: "$4"
                },
                mutate: mutate
            })
        ]
    });
};
/* harmony default export */ var filters_SelectedAttributes = (SelectedAttributes);

// EXTERNAL MODULE: ./components/primitives/Grid.tsx
var Grid = __webpack_require__(95738);
// EXTERNAL MODULE: ./node_modules/usehooks-ts/dist/esm/index.js + 36 modules
var esm = __webpack_require__(5678);
// EXTERNAL MODULE: ./components/primitives/Dropdown.tsx
var Dropdown = __webpack_require__(12623);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dropdown-menu/dist/index.module.js + 8 modules
var index_module = __webpack_require__(99842);
// EXTERNAL MODULE: ./node_modules/react-responsive/dist/react-responsive.js
var react_responsive = __webpack_require__(1852);
;// CONCATENATED MODULE: ./components/collections/SortTokens.tsx










const options = {
    "Price low to high": {
        sortBy: "floorAskPrice",
        sortDirection: "asc"
    },
    "Price high to low": {
        sortBy: "floorAskPrice",
        sortDirection: "desc"
    },
    "Rare to common": {
        sortBy: "rarity",
        sortDirection: "asc"
    },
    "Common to rare": {
        sortBy: "rarity",
        sortDirection: "desc"
    }
};
const SortTokens = (param)=>{
    let { css  } = param;
    const router = (0,next_router.useRouter)();
    const [sortSelection, setSortSelection] = (0,react.useState)("Price low to high");
    const isMounted = (0,hooks/* useMounted */.s4)();
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 905
    }) && isMounted;
    (0,react.useEffect)(()=>{
        var _router_query_sortBy, _router_query_sortDirection;
        const sortBy = (_router_query_sortBy = router === null || router === void 0 ? void 0 : router.query["sortBy"]) === null || _router_query_sortBy === void 0 ? void 0 : _router_query_sortBy.toString();
        const sortDirection = (_router_query_sortDirection = router === null || router === void 0 ? void 0 : router.query["sortDirection"]) === null || _router_query_sortDirection === void 0 ? void 0 : _router_query_sortDirection.toString();
        if (sortBy === "rarity" && sortDirection === "desc") {
            setSortSelection("Common to rare");
            return;
        }
        if (sortBy === "rarity" && sortDirection === "asc") {
            setSortSelection("Rare to common");
            return;
        }
        if (sortBy === "floorAskPrice" && sortDirection === "desc") {
            setSortSelection("Price high to low");
            return;
        }
        setSortSelection("Price low to high");
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_module/* Root */.fC, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_module/* Trigger */.xz, {
                asChild: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                    color: "gray3",
                    css: {
                        ...css
                    },
                    children: isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faSort */.CmM,
                        width: 16,
                        height: 16
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: sortSelection
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                css: {
                                    transition: "transform",
                                    "[data-state=open] &": {
                                        transform: "rotate(180deg)"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                    icon: free_solid_svg_icons/* faChevronDown */.ptq,
                                    width: 16
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuContent */.AW, {
                css: {
                    width: "220px",
                    mt: "$2",
                    zIndex: 1000
                },
                children: Object.keys(options).map((key)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* DropdownMenuItem */.Xi, {
                        css: {
                            py: "$3"
                        },
                        onClick: ()=>{
                            router.push({
                                query: {
                                    ...router.query,
                                    ["sortBy"]: options[key].sortBy,
                                    ["sortDirection"]: options[key].sortDirection
                                }
                            }, undefined, {
                                shallow: true
                            });
                        },
                        "aria-label": "Sort by ".concat(key),
                        children: key
                    }, key))
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/primitives/Tab.tsx
var Tab = __webpack_require__(53370);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-tabs/dist/index.module.js
var dist_index_module = __webpack_require__(36888);
// EXTERNAL MODULE: ./components/common/ActivityTable.tsx
var ActivityTable = __webpack_require__(31322);
;// CONCATENATED MODULE: ./components/collections/CollectionActivityTable.tsx




const CollectionActivityTable = (param)=>{
    let { id , activityTypes  } = param;
    const data = (0,dist/* useCollectionActivity */.UH)({
        collection: id,
        types: activityTypes,
        limit: 20
    }, {
        revalidateOnMount: true,
        fallbackData: []
    });
    (0,react.useEffect)(()=>{
        data.mutate();
        return ()=>{
            data.setSize(1);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityTable/* ActivityTable */.T, {
        data: data
    });
};

// EXTERNAL MODULE: ./components/common/ActivityFilters.tsx
var ActivityFilters = __webpack_require__(18733);
// EXTERNAL MODULE: ./node_modules/@radix-ui/react-dialog/dist/index.mjs + 15 modules
var react_dialog_dist = __webpack_require__(60430);
// EXTERNAL MODULE: ./components/common/FullscreenModal.tsx
var FullscreenModal = __webpack_require__(18491);
;// CONCATENATED MODULE: ./components/collections/filters/MobileAttributeFilters.tsx











const MobileAttributeFilters = (param)=>{
    let { attributes , scrollToTop  } = param;
    const router = (0,next_router.useRouter)();
    const [filtersLength, setFiltersLength] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        let filters = [];
        // Extract all queries of attribute type
        Object.keys({
            ...router.query
        }).map((key)=>{
            if (key.startsWith("attributes[") && key.endsWith("]") && router.query[key] !== "") {
                if (Array.isArray(router.query[key])) {
                    let values = router.query[key];
                    values.forEach((value)=>{
                        filters.push({
                            key: key.slice(11, -1),
                            value: value
                        });
                    });
                } else {
                    filters.push({
                        key: key.slice(11, -1),
                        value: router.query[key]
                    });
                }
            }
        });
        setFiltersLength(filters.length);
    }, [
        router.query
    ]);
    let filtersEnabled = filtersLength > 0;
    const trigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
        justify: "center",
        css: {
            position: "fixed",
            left: 0,
            bottom: "70px",
            width: "100vw",
            zIndex: 99
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Button */.zx, {
            css: {
                justifyContent: "center",
                alignItems: "center",
                justifyItems: "center",
                position: "fixed",
                px: "$6",
                py: "$3",
                boxShadow: "0px 1px 5px rgba(0,0,0,0.2)"
            },
            type: "button",
            size: "small",
            corners: "pill",
            color: "gray3",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                    style: "h6",
                    children: "Filter"
                }),
                filtersEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                    justify: "center",
                    align: "center",
                    css: {
                        height: "24px",
                        width: "24px",
                        backgroundColor: "$gray4",
                        borderRadius: "100%",
                        fontSize: "medium",
                        fontWeight: "500"
                    },
                    children: filtersLength
                })
            ]
        })
    });
    if (attributes && (attributes === null || attributes === void 0 ? void 0 : attributes.length) === 0 || attributes === null || attributes === undefined) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullscreenModal/* FullscreenModal */.O, {
        trigger: trigger,
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                css: {
                    flexDirection: "column",
                    height: "100%",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                        css: {
                            height: navbar/* NAVBAR_HEIGHT_MOBILE */.t7,
                            py: "$4",
                            px: "$4",
                            width: "100%",
                            borderBottom: "1px solid $gray4"
                        },
                        align: "center",
                        justify: "between",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "h5",
                                        css: {
                                            mr: "$3"
                                        },
                                        children: "Filter"
                                    }),
                                    filtersEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                        justify: "center",
                                        css: {
                                            height: "24px",
                                            width: "24px",
                                            backgroundColor: "$gray3",
                                            borderRadius: "100%",
                                            mr: "$3"
                                        },
                                        children: filtersLength
                                    }),
                                    filtersEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Button */.zx, {
                                        onClick: ()=>clearAllAttributes(router),
                                        color: "ghost",
                                        size: "small",
                                        css: {
                                            color: "$primary11",
                                            fontWeight: 400
                                        },
                                        children: "Clear all"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_dialog_dist/* Close */.x8, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                    css: {
                                        justifyContent: "center",
                                        width: "44px",
                                        height: "44px",
                                        alignItems: "center",
                                        borderRadius: 8,
                                        backgroundColor: "$gray3",
                                        color: "$gray12",
                                        "&:hover": {
                                            backgroundColor: "$gray4"
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                        icon: free_solid_svg_icons/* faXmark */.g82,
                                        width: 16,
                                        height: 16
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                        css: {
                            width: "100%",
                            maxHeight: "calc(100vh - ".concat(navbar/* NAVBAR_HEIGHT_MOBILE */.t7, "px)"),
                            overflowY: "auto"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                width: "100%"
                            },
                            children: attributes && attributes.filter((attribute)=>attribute.kind != "number").map((attribute)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeSelector, {
                                    attribute: attribute,
                                    scrollToTop: scrollToTop
                                }, attribute.key))
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./components/common/MobileActivityFilters.tsx
var MobileActivityFilters = __webpack_require__(33808);
// EXTERNAL MODULE: ./utils/titleCase.ts
var titleCase = __webpack_require__(68437);
// EXTERNAL MODULE: ./node_modules/@stitches/react/dist/index.mjs
var react_dist = __webpack_require__(86744);
;// CONCATENATED MODULE: ./components/common/LoadingCard.tsx



const pulse = (0,react_dist/* keyframes */.F4)({
    "0%": {
        backgroundColor: "$gray6"
    },
    "50%": {
        backgroundColor: "$gray8"
    },
    "100%": {
        backgroundColor: "$gray6"
    }
});
const LoadingCard = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
        direction: "column",
        justify: "end",
        css: {
            borderRadius: 8,
            overflow: "hidden",
            background: "$gray6",
            height: "100%",
            minHeight: 332,
            "@md": {
                minHeight: 372
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
            css: {
                background: "$gray4",
                p: "$4",
                height: 132
            },
            direction: "column",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        mb: "$4",
                        height: "100%"
                    },
                    align: "center",
                    justify: "between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                height: 20,
                                width: 120,
                                background: "$gray6",
                                animation: "".concat(pulse, " 2s ease-in infinite")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                height: 20,
                                width: 40,
                                background: "$gray6",
                                animation: "".concat(pulse, " 2s ease-in infinite")
                            }
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    css: {
                        mb: "$4",
                        height: "100%"
                    },
                    align: "center",
                    justify: "between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                height: 20,
                                width: 60,
                                background: "$gray6",
                                animation: "".concat(pulse, " 2s ease-in infinite")
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                            css: {
                                height: 20,
                                width: 20,
                                background: "$gray6",
                                animation: "".concat(pulse, " 2s ease-in infinite")
                            }
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var common_LoadingCard = (LoadingCard);

// EXTERNAL MODULE: ./pages/_app.tsx + 135 modules
var _app = __webpack_require__(76581);
// EXTERNAL MODULE: ./utils/chains.ts + 1 modules
var chains = __webpack_require__(79062);
// EXTERNAL MODULE: ./components/Head.tsx
var Head = __webpack_require__(4049);
// EXTERNAL MODULE: ./components/common/OpenSeaVerified.tsx
var OpenSeaVerified = __webpack_require__(44930);
// EXTERNAL MODULE: ./node_modules/wagmi/dist/index.js + 25 modules
var wagmi_dist = __webpack_require__(38793);
// EXTERNAL MODULE: ./components/primitives/Img.tsx
var Img = __webpack_require__(68916);
// EXTERNAL MODULE: ./utils/optimizeImage.ts
var optimizeImage = __webpack_require__(77497);
// EXTERNAL MODULE: ./components/common/CopyText.tsx
var CopyText = __webpack_require__(56373);
// EXTERNAL MODULE: ./node_modules/@fortawesome/free-brands-svg-icons/index.mjs
var free_brands_svg_icons = __webpack_require__(93024);
// EXTERNAL MODULE: ./stitches.config.ts + 2 modules
var stitches_config = __webpack_require__(31139);
// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var next_themes_dist_index_module = __webpack_require__(82010);
// EXTERNAL MODULE: ./utils/fetcher.ts
var fetcher = __webpack_require__(84205);
// EXTERNAL MODULE: ./utils/till.ts
var till = __webpack_require__(94830);
;// CONCATENATED MODULE: ./components/collections/CollectionActions.tsx















const CollectionAction = (0,stitches_config/* styled */.zo)(primitives/* Flex */.kC, {
    px: "$4",
    py: "$4",
    color: "$gray12",
    background: "$gray2",
    cursor: "pointer",
    transition: "background 0.25s ease-in",
    height: 48,
    alignItems: "center",
    "&:hover": {
        background: "$gray4"
    }
});
const CollectionActionDropdownItem = (0,stitches_config/* styled */.zo)(primitives/* Flex */.kC, {
    gap: "$3",
    cursor: "pointer",
    alignItems: "center",
    flexDirection: "row",
    px: "$4",
    py: 20,
    transition: "background 0.25s ease-in",
    "&:hover": {
        background: "$gray4"
    }
});
const CollectionActions = (param)=>{
    let { collection  } = param;
    var _marketplaceChain_blockExplorers, _marketplaceChain_blockExplorers1;
    const { addToast  } = (0,react.useContext)(ToastContextProvider/* ToastContext */.u);
    const isMounted = (0,hooks/* useMounted */.s4)();
    const isMobile = (0,react_responsive.useMediaQuery)({
        maxWidth: 600
    }) && isMounted;
    const [isRefreshing, setIsRefreshing] = (0,react.useState)(false);
    const marketplaceChain = (0,hooks/* useMarketplaceChain */.gw)();
    const { theme  } = (0,next_themes_dist_index_module/* useTheme */.F)();
    const etherscanImage = /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: isMounted && theme === "dark" ? "/icons/etherscan-logo-light-circle.svg" : "/icons/etherscan-logo-circle.svg",
        alt: ((_marketplaceChain_blockExplorers = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers === void 0 ? void 0 : _marketplaceChain_blockExplorers.default.name) || "Etherscan",
        style: {
            height: 16,
            width: 16
        }
    });
    const blockExplorerUrl = "".concat((marketplaceChain === null || marketplaceChain === void 0 ? void 0 : (_marketplaceChain_blockExplorers1 = marketplaceChain.blockExplorers) === null || _marketplaceChain_blockExplorers1 === void 0 ? void 0 : _marketplaceChain_blockExplorers1.default.url) || "https://etherscan.io", "/address/").concat(collection === null || collection === void 0 ? void 0 : collection.id);
    const twitterLink = (collection === null || collection === void 0 ? void 0 : collection.twitterUsername) ? "https://twitter.com/".concat(collection === null || collection === void 0 ? void 0 : collection.twitterUsername) : null;
    const containerCss = {
        borderRadius: 8,
        overflow: "hidden",
        gap: 0,
        bg: "$panelBg"
    };
    const dropdownContentProps = {
        sideOffset: 4,
        style: {
            padding: 0,
            overflow: "hidden"
        }
    };
    const collectionActionOverflowTrigger = /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
            icon: free_solid_svg_icons/* faEllipsis */.S6C,
            width: 16,
            height: 16
        })
    });
    const refreshMetadataItem = /*#__PURE__*/ (0,jsx_runtime.jsxs)(CollectionActionDropdownItem, {
        css: {
            cursor: isRefreshing ? "not-allowed" : "pointer"
        },
        onClick: (e)=>{
            if (isRefreshing) {
                e.preventDefault();
                return;
            }
            setIsRefreshing(true);
            (0,fetcher/* default */.ZP)("".concat(window.location.origin, "/").concat(marketplaceChain.proxyApi, "/collections/refresh/v2"), undefined, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    collection: collection.id
                })
            }).then((param)=>{
                let { data , response  } = param;
                if (response.status === 200) {
                    addToast === null || addToast === void 0 ? void 0 : addToast({
                        title: "Refresh collection",
                        description: "Request to refresh collection was accepted."
                    });
                } else {
                    throw data;
                }
                setIsRefreshing(false);
            }).catch((e)=>{
                var _DATE_REGEX_exec;
                const ratelimit = (_DATE_REGEX_exec = till/* DATE_REGEX.exec */.n.exec(e === null || e === void 0 ? void 0 : e.message)) === null || _DATE_REGEX_exec === void 0 ? void 0 : _DATE_REGEX_exec[0];
                addToast === null || addToast === void 0 ? void 0 : addToast({
                    title: "Refresh collection failed",
                    description: ratelimit ? "This collection was recently refreshed. The next available refresh is ".concat((0,till/* timeTill */.x)(ratelimit), ".") : "This collection was recently refreshed. Please try again later."
                });
                setIsRefreshing(false);
                throw e;
            });
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                css: {
                    animation: isRefreshing ? "".concat(LoadingSpinner/* spin */.O, " 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite") : "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                    icon: free_solid_svg_icons/* faRefresh */.QDM,
                    width: 16,
                    height: 16
                })
            }),
            "Refresh Metadata"
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        css: containerCss,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: blockExplorerUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                    children: etherscanImage
                })
            }),
            twitterLink && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: twitterLink,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_brands_svg_icons/* faTwitter */.mdU,
                        width: 16,
                        height: 16
                    })
                })
            }),
            (collection === null || collection === void 0 ? void 0 : collection.discordUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: collection === null || collection === void 0 ? void 0 : collection.discordUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_brands_svg_icons/* faDiscord */.omb,
                        width: 16,
                        height: 16
                    })
                })
            }),
            (collection === null || collection === void 0 ? void 0 : collection.externalUrl) && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: collection.externalUrl,
                target: "_blank",
                rel: "noopener noreferrer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionAction, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                        icon: free_solid_svg_icons/* faGlobe */.g4A,
                        width: 16,
                        height: 16
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* Dropdown */.Lt, {
                trigger: collectionActionOverflowTrigger,
                contentProps: dropdownContentProps,
                children: refreshMetadataItem
            })
        ]
    });
};
/* harmony default export */ var collections_CollectionActions = (CollectionActions);

// EXTERNAL MODULE: ./node_modules/react-markdown/lib/react-markdown.js + 127 modules
var react_markdown = __webpack_require__(48329);
;// CONCATENATED MODULE: ./components/collections/CollectionDetails.tsx













const StyledImage = (0,stitches_config/* styled */.zo)("img", {});
const ItemGrid = (0,stitches_config/* styled */.zo)(primitives/* Box */.xu, {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "$4",
    "@md": {
        gridTemplateColumns: "repeat(4, 1fr)"
    },
    "@bp1500": {
        gridTemplateColumns: "repeat(5, 1fr)"
    }
});
const CollectionDetails = (param)=>{
    let { collection , collectionId , tokens  } = param;
    var _collection_contractKind, _collection_royalties, _collection_royalties1, _collection_floorAsk, _collection_floorAsk_price, _collection_floorAsk_price_amount, _collection_floorAsk1, _collection_floorAsk_price1, _collection_floorAsk_price_amount1, _collection_floorAsk2, _collection_floorAsk_price2, _collection_floorAsk_price_currency, _collection_topBid, _collection_topBid_price, _collection_topBid_price_amount, _collection_topBid1, _collection_topBid_price1, _collection_topBid_price_amount1, _collection_topBid2, _collection_topBid_price2, _collection_topBid_price_currency, _collection_volume, _collection_volume_1day, _collection_salesCount;
    const router = (0,next_router.useRouter)();
    const [descriptionExpanded, setDescriptionExpanded] = (0,react.useState)(false);
    const [isOverflowed, setIsOverflowed] = (0,react.useState)(false);
    const chainCurrency = (0,hooks/* useChainCurrency */.D5)();
    const descriptionRef = (0,react.useRef)(null);
    const contractKind = collection === null || collection === void 0 ? void 0 : (_collection_contractKind = collection.contractKind) === null || _collection_contractKind === void 0 ? void 0 : _collection_contractKind.toUpperCase();
    let creatorRoyalties = (collection === null || collection === void 0 ? void 0 : (_collection_royalties = collection.royalties) === null || _collection_royalties === void 0 ? void 0 : _collection_royalties.bps) ? (collection === null || collection === void 0 ? void 0 : (_collection_royalties1 = collection.royalties) === null || _collection_royalties1 === void 0 ? void 0 : _collection_royalties1.bps) * 0.01 : 0;
    let chain = (0,titleCase/* default */.Z)(router.query.chain);
    let rareTokenQuery = {
        limit: 8,
        collection: collectionId,
        includeLastSale: true,
        sortBy: "rarity",
        sortDirection: "asc"
    };
    (0,react.useEffect)(()=>{
        var _descriptionRef_current, _descriptionRef_current1;
        setIsOverflowed((descriptionRef === null || descriptionRef === void 0 ? void 0 : (_descriptionRef_current = descriptionRef.current) === null || _descriptionRef_current === void 0 ? void 0 : _descriptionRef_current.scrollHeight) > (descriptionRef === null || descriptionRef === void 0 ? void 0 : (_descriptionRef_current1 = descriptionRef.current) === null || _descriptionRef_current1 === void 0 ? void 0 : _descriptionRef_current1.clientHeight));
    }, [
        isOverflowed,
        descriptionRef
    ]);
    const { data: rareTokens  } = (0,dist/* useDynamicTokens */.XN)(rareTokenQuery);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        wrap: "wrap",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    width: "100%",
                    "@lg": {
                        width: 440
                    },
                    pb: "$5"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                        css: {
                            borderRadius: 8,
                            overflow: "hidden",
                            background: "$neutralBgSubtle",
                            $$shadowColor: "$colors$panelShadow",
                            boxShadow: "0 8px 12px 0px $$shadowColor",
                            position: "relative",
                            "&:hover > a > div > img": {
                                transform: "scale(1.1)"
                            },
                            "@sm": {
                                "&:hover .token-button-container": {
                                    bottom: 0
                                }
                            }
                        },
                        children: [
                            (collection === null || collection === void 0 ? void 0 : collection.banner) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledImage, {
                                src: (0,optimizeImage/* default */.Z)(collection === null || collection === void 0 ? void 0 : collection.banner, 1000),
                                css: {
                                    borderRadius: 8,
                                    borderBottomLeftRadius: 0,
                                    borderBottomRightRadius: 0,
                                    width: "100%",
                                    height: 300,
                                    "@md": {
                                        height: 350
                                    },
                                    "@lg": {
                                        height: 200
                                    },
                                    objectFit: "cover"
                                }
                            }) : null,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                css: {
                                    p: "$4"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Text */.xv, {
                                        style: "h6",
                                        as: "h6",
                                        css: {
                                            mb: "$1",
                                            fontWeight: 700
                                        },
                                        children: [
                                            "About ",
                                            collection === null || collection === void 0 ? void 0 : collection.name
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "body1",
                                        as: "p",
                                        ref: (ref)=>{
                                            if (!ref) return;
                                            descriptionRef.current = ref;
                                        },
                                        css: {
                                            lineHeight: 1.5,
                                            display: "-webkit-box",
                                            WebkitLineClamp: descriptionExpanded ? "reset" : 4,
                                            WebkitBoxOrient: "vertical",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_markdown/* ReactMarkdown */.D, {
                                            children: (collection === null || collection === void 0 ? void 0 : collection.description) || ""
                                        })
                                    }),
                                    isOverflowed && /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        onClick: ()=>setDescriptionExpanded(!descriptionExpanded),
                                        style: "body1",
                                        as: "p",
                                        css: {
                                            cursor: "pointer",
                                            mt: "$2",
                                            fontWeight: 600,
                                            textDecoration: "underline"
                                        },
                                        children: descriptionExpanded ? "Close" : "Expand"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                        css: {
                                            mt: "$4"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                            justify: "start",
                                            children: collection && /*#__PURE__*/ (0,jsx_runtime.jsx)(collections_CollectionActions, {
                                                collection: collection
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                        css: {
                            mt: "$5"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                css: {
                                    mb: "$2",
                                    fontWeight: 700
                                },
                                as: "h6",
                                style: "h6",
                                children: "Collection Details"
                            }),
                            [
                                {
                                    label: "Contract",
                                    value: (0,truncate/* truncateAddress */.F)((collection === null || collection === void 0 ? void 0 : collection.primaryContract) || "")
                                },
                                {
                                    label: "Token Standard",
                                    value: contractKind
                                },
                                {
                                    label: "Chain",
                                    value: chain
                                },
                                {
                                    label: "Creator Earning",
                                    value: creatorRoyalties + "%"
                                },
                                {
                                    label: "Total Supply",
                                    value: collection === null || collection === void 0 ? void 0 : collection.tokenCount
                                }
                            ].map((data)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    css: {
                                        gap: "$4",
                                        justifyContent: "space-between",
                                        mb: "$2"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "body1",
                                            color: "subtle",
                                            children: data.label
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                            style: "body1",
                                            css: {
                                                fontWeight: 600
                                            },
                                            children: data.value
                                        })
                                    ]
                                }))
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                css: {
                    flex: 1,
                    "@lg": {
                        pl: "$5",
                        ml: "$2",
                        pt: "$2",
                        pb: "$6"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "h7",
                        as: "h5",
                        css: {
                            mb: "$3"
                        },
                        children: "Collection Stats"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemGrid, {
                        children: [
                            {
                                name: "Floor",
                                value: (collection === null || collection === void 0 ? void 0 : (_collection_floorAsk = collection.floorAsk) === null || _collection_floorAsk === void 0 ? void 0 : (_collection_floorAsk_price = _collection_floorAsk.price) === null || _collection_floorAsk_price === void 0 ? void 0 : (_collection_floorAsk_price_amount = _collection_floorAsk_price.amount) === null || _collection_floorAsk_price_amount === void 0 ? void 0 : _collection_floorAsk_price_amount.decimal) ? "".concat(collection === null || collection === void 0 ? void 0 : (_collection_floorAsk1 = collection.floorAsk) === null || _collection_floorAsk1 === void 0 ? void 0 : (_collection_floorAsk_price1 = _collection_floorAsk1.price) === null || _collection_floorAsk_price1 === void 0 ? void 0 : (_collection_floorAsk_price_amount1 = _collection_floorAsk_price1.amount) === null || _collection_floorAsk_price_amount1 === void 0 ? void 0 : _collection_floorAsk_price_amount1.decimal, " ").concat(collection === null || collection === void 0 ? void 0 : (_collection_floorAsk2 = collection.floorAsk) === null || _collection_floorAsk2 === void 0 ? void 0 : (_collection_floorAsk_price2 = _collection_floorAsk2.price) === null || _collection_floorAsk_price2 === void 0 ? void 0 : (_collection_floorAsk_price_currency = _collection_floorAsk_price2.currency) === null || _collection_floorAsk_price_currency === void 0 ? void 0 : _collection_floorAsk_price_currency.symbol) : "-"
                            },
                            {
                                name: "Top Bid",
                                value: (collection === null || collection === void 0 ? void 0 : (_collection_topBid = collection.topBid) === null || _collection_topBid === void 0 ? void 0 : (_collection_topBid_price = _collection_topBid.price) === null || _collection_topBid_price === void 0 ? void 0 : (_collection_topBid_price_amount = _collection_topBid_price.amount) === null || _collection_topBid_price_amount === void 0 ? void 0 : _collection_topBid_price_amount.decimal) ? "".concat((collection === null || collection === void 0 ? void 0 : (_collection_topBid1 = collection.topBid) === null || _collection_topBid1 === void 0 ? void 0 : (_collection_topBid_price1 = _collection_topBid1.price) === null || _collection_topBid_price1 === void 0 ? void 0 : (_collection_topBid_price_amount1 = _collection_topBid_price1.amount) === null || _collection_topBid_price_amount1 === void 0 ? void 0 : _collection_topBid_price_amount1.decimal) || 0, " ").concat(collection === null || collection === void 0 ? void 0 : (_collection_topBid2 = collection.topBid) === null || _collection_topBid2 === void 0 ? void 0 : (_collection_topBid_price2 = _collection_topBid2.price) === null || _collection_topBid_price2 === void 0 ? void 0 : (_collection_topBid_price_currency = _collection_topBid_price2.currency) === null || _collection_topBid_price_currency === void 0 ? void 0 : _collection_topBid_price_currency.symbol) : "-"
                            },
                            {
                                name: "24h Volume",
                                value: "".concat(Number(collection === null || collection === void 0 ? void 0 : (_collection_volume = collection.volume) === null || _collection_volume === void 0 ? void 0 : (_collection_volume_1day = _collection_volume["1day"]) === null || _collection_volume_1day === void 0 ? void 0 : _collection_volume_1day.toFixed(2)).toLocaleString(), " ").concat(chainCurrency.symbol)
                            },
                            {
                                name: "24h Sales",
                                value: Number("".concat((collection === null || collection === void 0 ? void 0 : (_collection_salesCount = collection.salesCount) === null || _collection_salesCount === void 0 ? void 0 : _collection_salesCount["1day"]) || 0)).toLocaleString()
                            }
                        ].map((stat)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                css: {
                                    p: "$4",
                                    borderRadius: 8,
                                    overflow: "hidden",
                                    background: "$neutralBgSubtle",
                                    $$shadowColor: "$colors$panelShadow",
                                    boxShadow: "0 0px 12px 0px $$shadowColor",
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "subtitle1",
                                        as: "p",
                                        children: stat.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                        style: "h5",
                                        css: {
                                            fontWeight: 800
                                        },
                                        children: stat.value
                                    })
                                ]
                            }))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "h7",
                        as: "h5",
                        css: {
                            mb: "$3",
                            mt: "$5"
                        },
                        children: "Rare Tokens"
                    }),
                    rareTokens.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemGrid, {
                        children: rareTokens.slice(0, 4).map((token)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TokenCard, {
                                showAsk: false,
                                token: token,
                                showSource: false,
                                rarityEnabled: false
                            }))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        children: "No rare tokens"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        style: "h7",
                        as: "h5",
                        css: {
                            mb: "$3",
                            mt: "$5"
                        },
                        children: "Floor Tokens"
                    }),
                    rareTokens.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ItemGrid, {
                        children: tokens.slice(0, 4).map((token)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TokenCard, {
                                showAsk: false,
                                token: token,
                                showSource: false,
                                rarityEnabled: false
                            }))
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                        children: "No Tokens"
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./context/WebsocketContextProvider.tsx
var WebsocketContextProvider = __webpack_require__(20512);
;// CONCATENATED MODULE: ./hooks/useChainWebsocket.ts
// WEBSOCKETS DISABLED: Reservoir's realtime websocket API is discontinued.
// This hook is kept as a no-op so call sites (useTokenUpdateStream, collection
// pages) keep working without opening dead socket connections. Live updates
// now come from SWR polling against the server-side Alchemy translation layer.
/* harmony default export */ function useChainWebsocket(_chainId) {
    let _options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return {
        sendMessage: function() {
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++){
                _args[_key] = arguments[_key];
            }
        },
        sendJsonMessage: function() {
            for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++){
                _args[_key] = arguments[_key];
            }
        },
        lastMessage: null,
        lastJsonMessage: null,
        readyState: 3,
        getWebSocket: ()=>null
    };
};

;// CONCATENATED MODULE: ./utils/validateEvent.ts
/**
 * # validateEvent
 * Validates an event that is recieved from the WebSocket
 * @param event  Incoming WebSocket message
 * @returns {undefined | ReservoirWebsocketIncomingEvent} undefined | ReservoirWebsocketIncomingEvent
 */ function validateEvent(event) {
    if (!event.data || typeof event.data !== "string") {
        return;
    }
    let reservoirEvent;
    try {
        reservoirEvent = JSON.parse(event.data);
    } catch (e) {
        return;
    }
    if (!reservoirEvent) {
        return;
    }
    return reservoirEvent;
}
/* harmony default export */ var utils_validateEvent = (validateEvent);

;// CONCATENATED MODULE: ./hooks/useTokenUpdateStream.ts







/* harmony default export */ function useTokenUpdateStream(contract, chainId) {
    let options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    const client = (0,dist/* useReservoirClient */.RW)();
    const activeChain = chainId !== undefined ? client === null || client === void 0 ? void 0 : client.chains.find((chain)=>chain.id === chainId) : client === null || client === void 0 ? void 0 : client.currentChain();
    const chain = chains/* default.find */.Z.find((chain)=>{
        return chain.id === (activeChain === null || activeChain === void 0 ? void 0 : activeChain.id);
    }) || chains/* DefaultChain */.j;
    const onMessage = (event)=>{
        if (!utils_validateEvent(event)) return;
        if (options.onMessage) {
            return options.onMessage({
                ...event,
                data: JSON.parse(event.data)
            });
        }
    };
    const onOpen = (event)=>{
        if (options.onOpen) {
            return options.onOpen(event);
        }
    };
    const onClose = (event)=>{
        if (options.onClose) {
            return options.onClose;
        }
    };
    const websocket = useChainWebsocket(chain.id, {
        ...options,
        onMessage,
        onClose,
        onOpen
    });
    const websocketContext = (0,react.useContext)(WebsocketContextProvider/* WebsocketContext */.U);
    (0,react.useEffect)(()=>{
        const subscribeMessages = [
            {
                type: "subscribe",
                event: "token.updated",
                filters: {
                    contract
                },
                changed: _app.NORMALIZE_ROYALTIES ? "market.floorAskNormalized.id" : "market.floorAsk.id"
            }
        ];
        const unsubscribeMessages = [
            {
                type: "unsubscribe",
                event: "token.updated",
                filters: {
                    contract
                },
                changed: _app.NORMALIZE_ROYALTIES ? "market.floorAskNormalized.id" : "market.floorAsk.id"
            }
        ];
        const sendSubscribeMessages = (message)=>{
            websocket.sendJsonMessage(message);
        };
        const sendUnsubscribeMessages = (message)=>{
            websocket.sendJsonMessage(message);
        };
        websocketContext === null || websocketContext === void 0 ? void 0 : websocketContext.subscribe(chain.id, subscribeMessages, sendSubscribeMessages, sendUnsubscribeMessages);
        return ()=>{
            websocketContext === null || websocketContext === void 0 ? void 0 : websocketContext.subscribe(chain.id, unsubscribeMessages, sendSubscribeMessages, sendUnsubscribeMessages);
        };
    }, [
        contract
    ]);
    return websocket;
};

;// CONCATENATED MODULE: ./components/common/LiveState.tsx





const LiveState_pulse = (0,react_dist/* keyframes */.F4)({
    "0%": {
        transform: "scale(1)",
        boxShadow: "rgb(52, 199, 123) 0px 0px 0px 0px"
    },
    "100%": {
        boxShadow: "rgba(52, 199, 123, 0) 0px 0px 0px 6.5px"
    }
});
const States = {
    0: "Paused...",
    1: "Live"
};
const LiveState = ()=>{
    const router = (0,next_router.useRouter)();
    const [connectionStatus, setConnectionStatus] = (0,react.useState)(0);
    (0,react.useEffect)(()=>{
        setConnectionStatus(Object.keys(router.query).some((key)=>key.includes("attribute")) ? 0 : 1);
    }, [
        router.query
    ]);
    const connectionState = States[connectionStatus];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
        justify: "between",
        align: "center",
        css: {
            gap: "$2"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    width: 10,
                    height: 10,
                    borderRadius: "100%",
                    background: connectionStatus ? "#4CC38A" : "#F1A10D",
                    ...connectionStatus && {
                        animation: "3s ease 0s infinite normal none running ".concat(LiveState_pulse)
                    }
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                style: "subtitle2",
                children: connectionState
            })
        ]
    });
};
/* harmony default export */ var common_LiveState = (LiveState);

;// CONCATENATED MODULE: ./pages/[chain]/collection/[contract].tsx







































const CollectionPage = (param)=>{
    let { id , ssr  } = param;
    var _router_query_sortDirection, _router_query_sortBy, _collection_contractKind, _collection_floorAsk, _collection_floorAsk_price, _collection_floorAsk_price_amount, _ssr_collection, _ssr_collection_collections, _ssr_collection_collections_, _ssr_collection1, _ssr_collection_collections1, _ssr_collection_collections_1, _ssr_collection2, _ssr_collection_collections2, _ssr_collection_collections_2, _Number;
    const router = (0,next_router.useRouter)();
    const { address  } = (0,wagmi_dist/* useAccount */.mA)();
    const [attributeFiltersOpen, setAttributeFiltersOpen] = (0,react.useState)(false);
    const [activityFiltersOpen, setActivityFiltersOpen] = (0,react.useState)(true);
    const [tokenSearchQuery, setTokenSearchQuery] = (0,react.useState)("");
    const chainCurrency = (0,hooks/* useChainCurrency */.D5)();
    const debouncedSearch = (0,esm/* useDebounce */.Nr)(tokenSearchQuery, 500);
    const [socketState, setSocketState] = (0,react.useState)(null);
    const [activityTypes, setActivityTypes] = (0,react.useState)([
        "sale",
        "mint"
    ]);
    const [initialTokenFallbackData, setInitialTokenFallbackData] = (0,react.useState)(true);
    const isMounted = (0,hooks/* useMounted */.s4)();
    const isSmallDevice = (0,react_responsive.useMediaQuery)({
        maxWidth: 905
    }) && isMounted;
    const [playingElement, setPlayingElement] = (0,react.useState)();
    const loadMoreRef = (0,react.useRef)(null);
    const loadMoreObserver = (0,esm/* useIntersectionObserver */.S1)(loadMoreRef, {});
    const scrollRef = (0,react.useRef)(null);
    const collectionChain = chains/* default.find */.Z.find((chain)=>{
        var _router_query;
        return ((_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.chain) === chain.routePrefix;
    }) || chains/* DefaultChain */.j;
    const scrollToTop = ()=>{
        var _scrollRef_current;
        let top = (((_scrollRef_current = scrollRef.current) === null || _scrollRef_current === void 0 ? void 0 : _scrollRef_current.offsetTop) || 0) - (navbar/* NAVBAR_HEIGHT */.ik + 16);
        window.scrollTo({
            top: top
        });
    };
    let chain = (0,titleCase/* default */.Z)(router.query.chain);
    let collectionQuery = {
        id,
        includeSalesCount: true,
        includeMintStages: true
    };
    const { data: collections  } = (0,dist/* useCollections */.bX)(collectionQuery, {
        fallbackData: [
            ssr.collection
        ]
    });
    let collection = collections && collections[0];
    let tokenQuery = {
        limit: 20,
        collection: id,
        sortBy: "floorAskPrice",
        sortDirection: "asc",
        includeQuantity: true,
        includeLastSale: true,
        ...debouncedSearch.length > 0 && {
            tokenName: debouncedSearch
        }
    };
    const sortDirection = (_router_query_sortDirection = router.query["sortDirection"]) === null || _router_query_sortDirection === void 0 ? void 0 : _router_query_sortDirection.toString();
    const sortBy = (_router_query_sortBy = router.query["sortBy"]) === null || _router_query_sortBy === void 0 ? void 0 : _router_query_sortBy.toString();
    if (sortBy === "tokenId" || sortBy === "rarity") tokenQuery.sortBy = sortBy;
    if (sortDirection === "desc") tokenQuery.sortDirection = "desc";
    // Extract all queries of attribute type
    Object.keys({
        ...router.query
    }).map((key)=>{
        if (key.startsWith("attributes[") && key.endsWith("]") && router.query[key] !== "") {
            //@ts-ignore
            tokenQuery[key] = router.query[key];
        }
    });
    const { data: tokens , mutate , fetchNextPage , setSize , resetCache , isFetchingInitialData , isFetchingPage , hasNextPage  } = (0,dist/* useDynamicTokens */.XN)(tokenQuery, {
        fallbackData: initialTokenFallbackData ? [
            ssr.tokens
        ] : undefined
    });
    useTokenUpdateStream(id, collectionChain.id, {
        onClose: ()=>setSocketState(0),
        onOpen: ()=>setSocketState(1),
        onMessage: (param)=>{
            let { data: reservoirEvent  } = param;
            var _reservoirEvent_data, _reservoirEvent_data_market, _reservoirEvent_data_market_floorAskNormalized, _reservoirEvent_data_market_floorAskNormalized_price, _reservoirEvent_data_market_floorAskNormalized_price_amount, _reservoirEvent_data1, _reservoirEvent_data_market1, _reservoirEvent_data_market_floorAsk, _reservoirEvent_data_market_floorAsk_price, _reservoirEvent_data_market_floorAsk_price_amount;
            if (Object.keys(router.query).some((key)=>key.includes("attribute"))) return;
            const tokenName = reservoirEvent.data.token.name || "";
            if (tokenSearchQuery && tokenSearchQuery.length > 0 && !tokenName.includes(tokenSearchQuery)) {
                return;
            }
            let hasChange = false;
            const newTokens = [
                ...tokens
            ];
            const price = _app.NORMALIZE_ROYALTIES ? (_reservoirEvent_data = reservoirEvent.data) === null || _reservoirEvent_data === void 0 ? void 0 : (_reservoirEvent_data_market = _reservoirEvent_data.market) === null || _reservoirEvent_data_market === void 0 ? void 0 : (_reservoirEvent_data_market_floorAskNormalized = _reservoirEvent_data_market.floorAskNormalized) === null || _reservoirEvent_data_market_floorAskNormalized === void 0 ? void 0 : (_reservoirEvent_data_market_floorAskNormalized_price = _reservoirEvent_data_market_floorAskNormalized.price) === null || _reservoirEvent_data_market_floorAskNormalized_price === void 0 ? void 0 : (_reservoirEvent_data_market_floorAskNormalized_price_amount = _reservoirEvent_data_market_floorAskNormalized_price.amount) === null || _reservoirEvent_data_market_floorAskNormalized_price_amount === void 0 ? void 0 : _reservoirEvent_data_market_floorAskNormalized_price_amount.native : (_reservoirEvent_data1 = reservoirEvent.data) === null || _reservoirEvent_data1 === void 0 ? void 0 : (_reservoirEvent_data_market1 = _reservoirEvent_data1.market) === null || _reservoirEvent_data_market1 === void 0 ? void 0 : (_reservoirEvent_data_market_floorAsk = _reservoirEvent_data_market1.floorAsk) === null || _reservoirEvent_data_market_floorAsk === void 0 ? void 0 : (_reservoirEvent_data_market_floorAsk_price = _reservoirEvent_data_market_floorAsk.price) === null || _reservoirEvent_data_market_floorAsk_price === void 0 ? void 0 : (_reservoirEvent_data_market_floorAsk_price_amount = _reservoirEvent_data_market_floorAsk_price.amount) === null || _reservoirEvent_data_market_floorAsk_price_amount === void 0 ? void 0 : _reservoirEvent_data_market_floorAsk_price_amount.native;
            const tokenIndex = tokens.findIndex((token)=>{
                var _token_token;
                return ((_token_token = token.token) === null || _token_token === void 0 ? void 0 : _token_token.tokenId) === (reservoirEvent === null || reservoirEvent === void 0 ? void 0 : reservoirEvent.data.token.tokenId);
            });
            const token = tokenIndex > -1 ? tokens[tokenIndex] : null;
            if (token) {
                var _token_market, _token_market_floorAsk;
                if (token === null || token === void 0 ? void 0 : (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : _token_market_floorAsk.dynamicPricing) {
                    return;
                }
                newTokens.splice(tokenIndex, 1);
            }
            if (!price) {
                if (token) {
                    const endOfListingsIndex = tokens.findIndex((token)=>{
                        var _token_market, _token_market_floorAsk, _token_market_floorAsk_price, _token_market_floorAsk_price_amount;
                        return !((_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : (_token_market_floorAsk_price = _token_market_floorAsk.price) === null || _token_market_floorAsk_price === void 0 ? void 0 : (_token_market_floorAsk_price_amount = _token_market_floorAsk_price.amount) === null || _token_market_floorAsk_price_amount === void 0 ? void 0 : _token_market_floorAsk_price_amount.native);
                    });
                    if (endOfListingsIndex === -1) {
                        hasChange = true;
                    } else {
                        const newTokenIndex = sortBy === "rarity" ? tokenIndex : endOfListingsIndex > -1 ? endOfListingsIndex : 0;
                        newTokens.splice(newTokenIndex, 0, {
                            ...token,
                            market: {
                                floorAsk: {
                                    id: undefined,
                                    price: undefined,
                                    maker: undefined,
                                    validFrom: undefined,
                                    validUntil: undefined,
                                    source: {}
                                }
                            }
                        });
                        hasChange = true;
                    }
                }
            } else {
                let updatedToken = token ? token : reservoirEvent.data;
                updatedToken = {
                    ...updatedToken,
                    market: {
                        floorAsk: _app.NORMALIZE_ROYALTIES ? reservoirEvent.data.market.floorAskNormalized : reservoirEvent.data.market.floorAsk
                    }
                };
                if (tokens) {
                    let updatedTokenPosition = sortBy === "rarity" ? tokenIndex : tokens.findIndex((token)=>{
                        var _token_market, _token_market_floorAsk, _token_market_floorAsk_price, _token_market_floorAsk_price_amount;
                        let currentTokenPrice = (_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : (_token_market_floorAsk_price = _token_market_floorAsk.price) === null || _token_market_floorAsk_price === void 0 ? void 0 : (_token_market_floorAsk_price_amount = _token_market_floorAsk_price.amount) === null || _token_market_floorAsk_price_amount === void 0 ? void 0 : _token_market_floorAsk_price_amount.native;
                        if (currentTokenPrice !== undefined) {
                            return sortDirection === "desc" ? updatedToken.market.floorAsk.price.amount.native >= currentTokenPrice : updatedToken.market.floorAsk.price.amount.native <= currentTokenPrice;
                        }
                        return true;
                    });
                    if (updatedTokenPosition <= -1) {
                        return;
                    }
                    newTokens.splice(updatedTokenPosition, 0, updatedToken);
                    hasChange = true;
                }
            }
            if (hasChange) {
                mutate([
                    {
                        tokens: newTokens
                    }
                ], {
                    revalidate: false,
                    optimisticData: [
                        {
                            tokens: newTokens
                        }
                    ]
                });
            }
        }
    });
    const attributesData = (0,dist/* useAttributes */.Ch)(id);
    const attributes = (0,react.useMemo)(()=>{
        var _attributesData_data;
        if ((_attributesData_data = attributesData.data) === null || _attributesData_data === void 0 ? void 0 : _attributesData_data.length) {
            var _attributesData_data1;
            return (_attributesData_data1 = attributesData.data) === null || _attributesData_data1 === void 0 ? void 0 : _attributesData_data1.filter((attribute)=>attribute.kind != "number" && attribute.kind != "range").sort((a, b)=>a.key.localeCompare(b.key));
        }
        // On-chain fallback when the indexer returns no attributes
        const fallback = ssr === null || ssr === void 0 ? void 0 : ssr.fallbackAttributes;
        if (Array.isArray(fallback) && fallback.length) {
            return fallback.filter((attribute)=>attribute.kind != "number" && attribute.kind != "range").sort((a, b)=>a.key.localeCompare(b.key));
        }
        return [];
    }, [
        attributesData.data,
        ssr
    ]);
    if (attributeFiltersOpen && attributesData.response && !attributes.length) {
        setAttributeFiltersOpen(false);
    }
    const rarityEnabledCollection = Boolean((collection === null || collection === void 0 ? void 0 : collection.tokenCount) && +collection.tokenCount >= 2 && attributes && (attributes === null || attributes === void 0 ? void 0 : attributes.length) >= 2);
    const contractKind = collection === null || collection === void 0 ? void 0 : (_collection_contractKind = collection.contractKind) === null || _collection_contractKind === void 0 ? void 0 : _collection_contractKind.toUpperCase();
    (0,react.useEffect)(()=>{
        const isVisible = !!(loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting);
        if (isVisible) {
            fetchNextPage();
        }
    }, [
        loadMoreObserver === null || loadMoreObserver === void 0 ? void 0 : loadMoreObserver.isIntersecting
    ]);
    (0,react.useEffect)(()=>{
        if (isMounted && initialTokenFallbackData) {
            setInitialTokenFallbackData(false);
        }
    }, [
        router.query
    ]);
    let nativePrice = collection === null || collection === void 0 ? void 0 : (_collection_floorAsk = collection.floorAsk) === null || _collection_floorAsk === void 0 ? void 0 : (_collection_floorAsk_price = _collection_floorAsk.price) === null || _collection_floorAsk_price === void 0 ? void 0 : (_collection_floorAsk_price_amount = _collection_floorAsk_price.amount) === null || _collection_floorAsk_price_amount === void 0 ? void 0 : _collection_floorAsk_price_amount.native;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Head/* Head */.F, {
                ogImage: ssr === null || ssr === void 0 ? void 0 : (_ssr_collection = ssr.collection) === null || _ssr_collection === void 0 ? void 0 : (_ssr_collection_collections = _ssr_collection.collections) === null || _ssr_collection_collections === void 0 ? void 0 : (_ssr_collection_collections_ = _ssr_collection_collections[0]) === null || _ssr_collection_collections_ === void 0 ? void 0 : _ssr_collection_collections_.banner,
                title: ssr === null || ssr === void 0 ? void 0 : (_ssr_collection1 = ssr.collection) === null || _ssr_collection1 === void 0 ? void 0 : (_ssr_collection_collections1 = _ssr_collection1.collections) === null || _ssr_collection_collections1 === void 0 ? void 0 : (_ssr_collection_collections_1 = _ssr_collection_collections1[0]) === null || _ssr_collection_collections_1 === void 0 ? void 0 : _ssr_collection_collections_1.name,
                description: ssr === null || ssr === void 0 ? void 0 : (_ssr_collection2 = ssr.collection) === null || _ssr_collection2 === void 0 ? void 0 : (_ssr_collection_collections2 = _ssr_collection2.collections) === null || _ssr_collection_collections2 === void 0 ? void 0 : (_ssr_collection_collections_2 = _ssr_collection_collections2[0]) === null || _ssr_collection_collections_2 === void 0 ? void 0 : _ssr_collection_collections_2.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_module/* Root */.fC, {
                defaultValue: "items",
                onValueChange: (value)=>{
                    if (value === "items") {
                        resetCache();
                        setSize(1);
                        mutate();
                    }
                },
                children: collection ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                    direction: "column",
                    css: {
                        px: "$4",
                        pt: "$4",
                        pb: 0,
                        "@md": {
                            px: "$5"
                        },
                        "@xl": {
                            px: "$6"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                            justify: "between",
                            wrap: "wrap",
                            css: {
                                mb: "$4",
                                gap: "$4"
                            },
                            align: "start",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                direction: "column",
                                css: {
                                    gap: "$4",
                                    minWidth: 0,
                                    //flex: 1,
                                    width: "100%",
                                    "@lg": {
                                        width: "unset"
                                    }
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                    css: {
                                        gap: "$4",
                                        flex: 1
                                    },
                                    align: "center",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Img/* default */.Z, {
                                            src: (0,optimizeImage/* default */.Z)(collection.image, 72 * 2),
                                            width: 72,
                                            height: 72,
                                            css: {
                                                width: 72,
                                                height: 72,
                                                borderRadius: 8,
                                                objectFit: "cover",
                                                border: "1px solid $gray5"
                                            },
                                            alt: "Collection Page Image"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                            css: {
                                                minWidth: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                    align: "center",
                                                    css: {
                                                        gap: "$1",
                                                        mb: 0
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                            style: "h4",
                                                            as: "h6",
                                                            ellipsify: true,
                                                            children: collection.name
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(OpenSeaVerified/* OpenSeaVerified */.v, {
                                                            openseaVerificationStatus: collection === null || collection === void 0 ? void 0 : collection.openseaVerificationStatus
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                    css: {
                                                        gap: "$3"
                                                    },
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(CopyText/* default */.Z, {
                                                            text: collection.id,
                                                            css: {
                                                                width: "max-content",
                                                                display: "flex",
                                                                alignItems: "center",
                                                                gap: "$1"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                                    css: {
                                                                        color: "$gray9"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        icon: free_solid_svg_icons/* faCube */.hGM,
                                                                        size: "xs"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                    as: "p",
                                                                    style: "body3",
                                                                    children: (0,truncate/* truncateAddress */.F)((collection === null || collection === void 0 ? void 0 : collection.primaryContract) || "")
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                            align: "center",
                                                            css: {
                                                                gap: "$1"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                                    css: {
                                                                        color: "$gray9"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        size: "xs",
                                                                        icon: free_solid_svg_icons/* faCog */.b7W
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                    style: "body3",
                                                                    children: contractKind
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                            align: "center",
                                                            css: {
                                                                gap: "$1"
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                                    css: {
                                                                        color: "$gray9"
                                                                    },
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                        size: "xs",
                                                                        icon: free_solid_svg_icons/* faGlobe */.g4A
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                    style: "body3",
                                                                    children: chain
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Tab/* TabsList */.dr, {
                            css: {
                                mt: 0
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                    value: "items",
                                    children: "Items"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                    value: "details",
                                    children: "Details"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsTrigger */.SP, {
                                    value: "activity",
                                    children: "Activity"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                            value: "items",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                css: {
                                    gap: attributeFiltersOpen ? "$5" : "",
                                    position: "relative"
                                },
                                ref: scrollRef,
                                children: [
                                    isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileAttributeFilters, {
                                        attributes: attributes,
                                        scrollToTop: scrollToTop
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AttributeFilters, {
                                            attributes: attributes,
                                            open: attributeFiltersOpen,
                                            setOpen: setAttributeFiltersOpen,
                                            scrollToTop: scrollToTop
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                        css: {
                                            flex: 1,
                                            width: "100%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                css: {
                                                    marginBottom: "$4",
                                                    gap: "$3"
                                                },
                                                align: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        align: "center",
                                                        css: {
                                                            gap: "$3",
                                                            flex: 1
                                                        },
                                                        children: [
                                                            attributes && attributes.length > 0 && !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* FilterButton */.L, {
                                                                open: attributeFiltersOpen,
                                                                setOpen: setAttributeFiltersOpen
                                                            }),
                                                            !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                                                css: {
                                                                    position: "relative",
                                                                    flex: 1,
                                                                    maxWidth: 420
                                                                },
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                                        css: {
                                                                            position: "absolute",
                                                                            top: "50%",
                                                                            left: "$4",
                                                                            zIndex: 2,
                                                                            transform: "translate(0, -50%)",
                                                                            color: "$gray11"
                                                                        },
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                                            icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Input */.II, {
                                                                        css: {
                                                                            pl: 42
                                                                        },
                                                                        placeholder: "Search by token name",
                                                                        onChange: (e)=>{
                                                                            setTokenSearchQuery(e.target.value);
                                                                        },
                                                                        value: tokenSearchQuery
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    socketState !== null && /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LiveState, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Flex */.kC, {
                                                        justify: "end",
                                                        css: {
                                                            width: "100%",
                                                            gap: "$2",
                                                            "@md": {
                                                                width: "max-content",
                                                                gap: "$3"
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SortTokens, {
                                                            css: {
                                                                order: 4,
                                                                px: "14px",
                                                                justifyContent: "center",
                                                                "@md": {
                                                                    order: 1,
                                                                    width: "220px",
                                                                    height: "48px",
                                                                    minWidth: "max-content",
                                                                    px: "$5"
                                                                }
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(filters_SelectedAttributes, {
                                                collection: collection,
                                                mutate: mutate
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                css: {
                                                    gap: "$4",
                                                    mb: "$3",
                                                    flexWrap: "wrap",
                                                    "@bp800": {
                                                        display: "flex"
                                                    },
                                                    display: "flex"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        css: {
                                                            gap: "$1"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "body1",
                                                                as: "p",
                                                                color: "subtle",
                                                                children: "Floor"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "body1",
                                                                as: "p",
                                                                css: {
                                                                    fontWeight: "700"
                                                                },
                                                                children: nativePrice ? "".concat(nativePrice === null || nativePrice === void 0 ? void 0 : nativePrice.toFixed(2), " ").concat(chainCurrency.symbol) : "-"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                        css: {
                                                            gap: "$1"
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "body1",
                                                                as: "p",
                                                                color: "subtle",
                                                                children: "Count"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                                style: "body1",
                                                                as: "p",
                                                                css: {
                                                                    fontWeight: "700"
                                                                },
                                                                children: (_Number = Number(collection === null || collection === void 0 ? void 0 : collection.tokenCount)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString()
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* Grid */.r, {
                                                css: {
                                                    gap: "$4",
                                                    pb: "$6",
                                                    gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))",
                                                    "@md": {
                                                        gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))"
                                                    }
                                                },
                                                children: [
                                                    isFetchingInitialData ? Array(10).fill(null).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(common_LoadingCard, {}, "loading-card-".concat(index))) : tokens.map((token, i)=>{
                                                        var _token_market, _token_market_floorAsk, _token_market_floorAsk_maker;
                                                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TokenCard, {
                                                            token: token,
                                                            address: address,
                                                            mutate: mutate,
                                                            rarityEnabled: rarityEnabledCollection,
                                                            onMediaPlayed: (e)=>{
                                                                if (playingElement && playingElement !== e.nativeEvent.target) {
                                                                    playingElement.pause();
                                                                }
                                                                const element = e.nativeEvent.target || e.nativeEvent.target;
                                                                if (element) {
                                                                    setPlayingElement(element);
                                                                }
                                                            },
                                                            addToCartEnabled: ((_token_market = token.market) === null || _token_market === void 0 ? void 0 : (_token_market_floorAsk = _token_market.floorAsk) === null || _token_market_floorAsk === void 0 ? void 0 : (_token_market_floorAsk_maker = _token_market_floorAsk.maker) === null || _token_market_floorAsk_maker === void 0 ? void 0 : _token_market_floorAsk_maker.toLowerCase()) !== (address === null || address === void 0 ? void 0 : address.toLowerCase())
                                                        }, i);
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {
                                                        ref: loadMoreRef,
                                                        css: {
                                                            display: isFetchingPage ? "none" : "block"
                                                        },
                                                        children: (hasNextPage || isFetchingPage) && !isFetchingInitialData && /*#__PURE__*/ (0,jsx_runtime.jsx)(common_LoadingCard, {})
                                                    }),
                                                    (hasNextPage || isFetchingPage) && !isFetchingInitialData && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                        children: Array(6).fill(null).map((_, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(common_LoadingCard, {}, "loading-card-".concat(index)))
                                                    })
                                                ]
                                            }),
                                            tokens.length == 0 && !isFetchingPage && /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                                direction: "column",
                                                align: "center",
                                                css: {
                                                    py: "$6",
                                                    gap: "$4"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                        css: {
                                                            color: "$gray11"
                                                        },
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* FontAwesomeIcon */.G, {
                                                            icon: free_solid_svg_icons/* faMagnifyingGlass */.Y$T,
                                                            size: "2xl"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Text */.xv, {
                                                        css: {
                                                            color: "$gray11"
                                                        },
                                                        children: "No items found"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                            value: "details",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionDetails, {
                                collection: collection,
                                collectionId: id,
                                tokens: tokens
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tab/* TabsContent */.nU, {
                            value: "activity",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Flex */.kC, {
                                css: {
                                    gap: activityFiltersOpen ? "$5" : "",
                                    position: "relative"
                                },
                                children: [
                                    isSmallDevice ? /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileActivityFilters/* MobileActivityFilters */.r, {
                                        activityTypes: activityTypes,
                                        setActivityTypes: setActivityTypes
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityFilters/* ActivityFilters */.Y, {
                                        open: activityFiltersOpen,
                                        setOpen: setActivityFiltersOpen,
                                        activityTypes: activityTypes,
                                        setActivityTypes: setActivityTypes
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(primitives/* Box */.xu, {
                                        css: {
                                            flex: 1,
                                            gap: "$4",
                                            pb: "$5"
                                        },
                                        children: [
                                            !isSmallDevice && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterButton/* FilterButton */.L, {
                                                open: activityFiltersOpen,
                                                setOpen: setActivityFiltersOpen
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CollectionActivityTable, {
                                                id: id,
                                                activityTypes: activityTypes
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(primitives/* Box */.xu, {})
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _contract_ = (CollectionPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7948,7533,5348,8329,2077,1943,4646,7889,9774,2888,179], function() { return __webpack_exec__(53725); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);